
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.271 1a1.92 1.92 0 00-1.91 1.91v3.816a1.92 1.92 0 001.91 1.91h3.82a1.918 1.918 0 001.907-1.91V2.91c0-1.047-.86-1.91-1.907-1.91H9.27zm0 1.273h3.82c.363 0 .636.273.636.637v3.816a.622.622 0 01-.636.636H9.27a.622.622 0 01-.636-.637V2.91c0-.363.273-.636.636-.636zM2.91 3.546A1.92 1.92 0 001 5.456v1.27a1.92 1.92 0 001.909 1.91h1.273a1.918 1.918 0 001.907-1.91v-1.27c0-1.047-.86-1.91-1.907-1.91H2.91zm0 1.273h1.273a.62.62 0 01.634.636v1.27a.62.62 0 01-.634.637H2.91a.622.622 0 01-.636-.636v-1.27c0-.364.272-.637.636-.637zm0 5.09A1.919 1.919 0 001 11.816v1.273A1.92 1.92 0 002.909 15h1.273a1.918 1.918 0 001.907-1.91v-1.273c0-1.046-.86-1.909-1.907-1.909H2.91zm6.362 0a1.92 1.92 0 00-1.91 1.908v1.273A1.92 1.92 0 009.272 15h1.274a1.92 1.92 0 001.909-1.91v-1.273a1.919 1.919 0 00-1.91-1.909H9.272zM2.91 11.18h1.273a.62.62 0 01.634.636v1.273a.62.62 0 01-.634.637H2.91a.621.621 0 01-.636-.637v-1.273c0-.363.272-.636.636-.636zm6.362 0h1.274c.363 0 .636.273.636.636v1.273a.621.621 0 01-.636.637H9.27a.621.621 0 01-.636-.637v-1.273c0-.363.273-.636.636-.636z"}})])
          )
        }
      }
    